"use client"

import IndexFooter from "@repo/ui/footer"
import SigninModalProvider from "@repo/ui/signin"
import { useEffect, type ReactNode } from "react"
import { App, ConfigProvider } from "antd"

// 导入 Ant Design React 19 兼容补丁
import "@ant-design/v5-patch-for-react-19"

import { setGlobalModalInstance } from "@/common/utils/modal"
// import { LoginErrorModal } from "@/app/[locale]/_components/LoginErrorModal"
import { getAntdLocale } from "@repo/shared"
import { useLocale } from "next-intl"

interface LocaleLayoutProps {
	children: ReactNode
	authError?: string | null
}

/**
 * 内部组件：设置全局 Modal 实例
 * 用于在错误拦截器等非 React 组件中使用 App.useApp() 获取的 modal 实例
 */
function ModalProvider({ children }: { children: ReactNode }) {
	const { modal } = App.useApp()

	useEffect(() => {
		// 设置全局 modal 实例，供错误拦截器使用
		setGlobalModalInstance(modal)
	}, [modal])

	return <>{children}</>
}

export function LocaleLayout({ children, authError }: LocaleLayoutProps) {
	const hookLocale = useLocale()
	const locale = hookLocale || "en"
	const antdLocale = getAntdLocale(locale)

	const fontFamilyMap: Record<string, string> = {
		th: "var(--font-noto-sans-thai), var(--font-montserrat), var(--font-roboto), Arial, Helvetica, sans-serif",
	}
	const fontFamily = fontFamilyMap[locale] ?? "var(--font-montserrat), var(--font-roboto), Arial, Helvetica, sans-serif"

	return (
		<ConfigProvider
			locale={antdLocale}
			theme={{
				token: {
					fontFamily,
					colorPrimary: "#d7000f",
					borderRadius: 2,
				},
				components: {
					Select: {
						activeBorderColor: "#0C1019",
						hoverBorderColor: "#0C1019",
						optionSelectedBg: "transparent",
						optionSelectedColor: "#d7000f",
						activeOutlineColor: "transparent",
					},
					Input: {
						activeBorderColor: "#0C1019",
						hoverBorderColor: "#0C1019",
						activeShadow: "transparent",
					},
					DatePicker: {
						activeBorderColor: "#0C1019",
						hoverBorderColor: "#0C1019",
						activeShadow: "transparent",
					},
				},
			}}
		>
			<App>
				<ModalProvider>
					<SigninModalProvider>
						{children}
						<IndexFooter />
						{/* <LoginErrorModal errorMessage={authError} /> */}
					</SigninModalProvider>
				</ModalProvider>
			</App>
		</ConfigProvider>
	)
}
